import type { RouterOptions } from 'vue-router'
import MemberShipRoutes from '~/router/modules/memberShip'
// import ShopHomeRoutes from '~/router/shopModules/shopHome'
import HomeRoutes from '~/router/modules/home'
// import CompanyRoutes from '~/router/modules/company'

import knowledgeRoutes from '~/router/modules/knowledge'
import inquiryRoutes from '~/router/modules/inquiry'

const wholeRoutes: any[] = [
  ...MemberShipRoutes,
  // ...ShopHomeRoutes,
  // ...CompanyRoutes,
  ...HomeRoutes,
  ...knowledgeRoutes,
  ...inquiryRoutes,
]

export default {
  routes: (nuxtRoutes: RouterOptions['routes']) => {
    return [...wholeRoutes]
  },
}
